import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AbstractDynamicComponent } from '@components/abstracts';
import { PushFaq } from '@components/push-faq/models';
import { ButtonComponent } from '@shared/components/button';
import { SvgComponent } from '@shared/components/svg';
import { TitleComponent } from '@shared/components/title';

@Component({
  selector: 'app-push-faq',
  imports: [TitleComponent, RouterLink, ButtonComponent, SvgComponent],
  templateUrl: './push-faq.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PushFaqComponent extends AbstractDynamicComponent<PushFaq> {}
